export default () => ({
  root: {
    padding: '1.4rem',
  },
});
